import { Components, Theme } from '@mui/material';

const MuiTableCell: Components<Theme>['MuiTableCell'] = {
  styleOverrides: {
    head: ({ theme }) => ({
      color: theme.palette.text.disabled,
    }),
    body: ({ theme }) => ({
      '&:first-of-type': {
        borderLeft: `1px solid ${theme.palette.borderColor.main}`,
      },
      '&:last-of-type': {
        borderRight: `1px solid ${theme.palette.borderColor.main}`,
      },
    }),
    stickyHeader: ({ theme }) => ({
      backgroundColor: theme.palette.background.paper,
    }),
  },
};

export default MuiTableCell;
